const MESSAGE_MODULE_TYPES = {
  ONBOARDING: 'onboarding',
  CONFIRMATION: 'confirmation',
  WARNING: 'warning',
  DISMISSIBLE_CONFIRMATION: 'dismissibleConfirmation',
};

export default MESSAGE_MODULE_TYPES;
